import { render, staticRenderFns } from "./assign_user.vue?vue&type=template&id=23896fc8&scoped=true"
import script from "./assign_user.vue?vue&type=script&lang=js"
export * from "./assign_user.vue?vue&type=script&lang=js"
import style0 from "./assign_user.vue?vue&type=style&index=0&id=23896fc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23896fc8",
  null
  
)

export default component.exports